import smoothscroll from 'smoothscroll-polyfill'

import { isClient } from '../../common-core'

// kick off the polyfill!
if (isClient()) smoothscroll.polyfill()

export const scrollToElement = (
  element: HTMLElement | null,
  behavior: 'smooth' | 'auto',
  spacingTop = 0,
) => {
  if (!element) return
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const global = globalThis as any

  const scrollTop = global.pageYOffset || element.scrollTop
  const top = element.getBoundingClientRect().top + scrollTop - spacingTop

  global.parent.scrollTo({
    top,
    behavior,
  })
}

export const scrollToElementById = ({
  elementId,
  behavior = 'smooth',
  spacingTop = 0,
  addHeaderHeight = true,
}: {
  elementId: string
  behavior?: 'smooth' | 'auto'
  spacingTop?: number
  addHeaderHeight?: boolean
}) => {
  const elementTarget: HTMLElement | null = document.getElementById(elementId)

  const calculatedSpacingTop = addHeaderHeight
    ? (document.getElementById('header')?.getBoundingClientRect()?.height || 0) + spacingTop
    : spacingTop

  if (elementTarget) {
    setTimeout(() => {
      scrollToElement(elementTarget, behavior, calculatedSpacingTop)
    }, 0)
  }
}

export const scrollToElementInsideParent = (
  container: HTMLElement,
  element: HTMLElement,
  behavior: 'smooth' | 'auto',
) => {
  const offsetBottom = element.offsetTop + element.offsetHeight
  const position = offsetBottom - container.offsetHeight

  container.scroll({ top: position, behavior })
}
